const STORAGE_KEY = 'coredna_person';
const GEOLOCATION_TTL = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

class FormGeolocation {
	static #initialized = false;

	static initialize() {
		if (this.#initialized) return;
		this.#initialized = true;

		const execute = () => this.#safeExecute(this.#processFormGeolocation);

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => setTimeout(execute, 3000));
		} else {
			setTimeout(execute, 3000);
		}
	}

	static async #safeExecute(fn) {
		try {
			await fn.call(this);
		} catch (error) {
			console.warn('FormGeolocation error:', error);
		}
	}

	static async #processFormGeolocation() {
		if (!this.#hasTargetForms()) return;
		
		const geolocation = await this.#getGeolocationData();
		if (geolocation?.country || geolocation?.region) {
			this.#fillFormFields(geolocation);
		}
	}

	static async #getGeolocationData() {
		// First try to get from local storage
		const localData = this.#getFromLocalStorage();
		
		if (localData?.country || localData?.region) {
			return localData;
		}

		// If not available locally, fetch from API
		return await this.#fetchFromAPI();
	}

	static #getFromLocalStorage() {
		const storage = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
		const locationData = storage.customisation?.location;
		
		if (!locationData?.updatedAt) {
			return null;
		}

		// Check if data is still fresh
		const updatedAt = new Date(locationData.updatedAt).getTime();
		const isExpired = Date.now() - updatedAt > GEOLOCATION_TTL;
		
		if (isExpired) {
			return null;
		}

		return {
			country: locationData.country,
			region: locationData.region
		};
	}

	static async #fetchFromAPI() {
		const response = await fetch('https://www.coredna.com/geolocation');
		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}
		
		const data = await response.json();
		
		return {
			country: data.country || null,
			region: data.region || null
		};
	}

	static #hasTargetForms() {
		return document.querySelector('form input[name="_country"], form input[name="_state"]') !== null;
	}

	static #fillFormFields(geolocation) {
		const forms = document.querySelectorAll('form');
		
		forms.forEach(form => {
			const countryField = form.querySelector('input[name="_country"]');
			const stateField = form.querySelector('input[name="_state"]');

			if (countryField && countryField.type === 'hidden' && geolocation.country) {
				// Only fill if field is empty or has no value
				if (!countryField.value) {
					countryField.value = geolocation.country;
				}
			}

			if (stateField && stateField.type === 'hidden' && geolocation.region) {
				// Only fill if field is empty or has no value
				if (!stateField.value) {
					stateField.value = geolocation.region;
				}
			}
		});
	}
}

// Auto-initialize when module is loaded
FormGeolocation.initialize();

export default FormGeolocation;